import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { LOCATION_COMPONENTS_SEARCH_PARAMS } from "../../../../modules/Location/locationConstants";

function useIsSlideOpen() {
    const { search } = useLocation();

    return useMemo(() => {
        const searchParams = new URLSearchParams(search);
        return searchParams.has(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE);
    }, [search]);
}

export default useIsSlideOpen;
